/**
 * Keeps a value between two bounds.
 *
 * @param value - The value to bound.
 * @param min - Lowest value allowed.
 * @param max - Highest value allowed.
 */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
